import { ArticleBoxProps } from '@/components/boxes';
import { LINKS } from '@/constants/links';
import { PressRelease } from '@/types/pressRelease';

export function mapPressReleasesToArticles(pressReleases: PressRelease[]): ArticleBoxProps[] {
	return pressReleases.map((pressRelease) => ({
		name: pressRelease.name || '',
		content: pressRelease.perex || '',
		date: pressRelease.date as string,
		link: LINKS().pressReleaseDetail(pressRelease.slug.current || ''),
	}));
}
